// Author Lin
// Date 2022-03-07 21:48:55

class SithMesMstMaterialDocument {
constructor({
        id = null,
        materialNumber = '',
        documentType = '',
        documentNumber = '',
        documentPart = '',
        documentVersion = '',
        documentDescription = '',
        remark = ''}
= {}) {
    this.id = id;
    this.materialNumber = materialNumber;
    this.documentType = documentType;
    this.documentNumber = documentNumber;
    this.documentPart = documentPart;
    this.documentVersion = documentVersion;
    this.documentDescription = documentDescription;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesMstMaterialDocument();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.mst.sithMesMstMaterialDocument.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'materialNumber',
        label: 'label.sith.mst.sithMesMstMaterialDocument.grid.materialNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'documentType',
        label: 'label.sith.mst.sithMesMstMaterialDocument.grid.documentType',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'documentNumber',
        label: 'label.sith.mst.sithMesMstMaterialDocument.grid.documentNumber',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'documentPart',
        label: 'label.sith.mst.sithMesMstMaterialDocument.grid.documentPart',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'documentVersion',
        label: 'label.sith.mst.sithMesMstMaterialDocument.grid.documentVersion',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'documentDescription',
        label: 'label.sith.mst.sithMesMstMaterialDocument.grid.documentDescription',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstMaterialDocument.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    materialNumberFilter : '',
    documentTypeFilter : '',
    documentNumberFilter : '',
    documentPartFilter : '',
    documentVersionFilter : '',
    documentDescriptionFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'materialNumberFilter',
        label: 'label.sith.mst.sithMesMstMaterialDocument.filter.materialNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'documentTypeFilter',
        label: 'label.sith.mst.sithMesMstMaterialDocument.filter.documentType',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'documentNumberFilter',
        label: 'label.sith.mst.sithMesMstMaterialDocument.filter.documentNumber',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'documentPartFilter',
        label: 'label.sith.mst.sithMesMstMaterialDocument.filter.documentPart',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'documentVersionFilter',
        label: 'label.sith.mst.sithMesMstMaterialDocument.filter.documentVersion',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'documentDescriptionFilter',
        label: 'label.sith.mst.sithMesMstMaterialDocument.filter.documentDescription',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'materialNumber',
        label: 'label.sith.mst.sithMesMstMaterialDocument.entity.materialNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'documentType',
        label: 'label.sith.mst.sithMesMstMaterialDocument.entity.documentType',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'documentNumber',
        label: 'label.sith.mst.sithMesMstMaterialDocument.entity.documentNumber',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'documentPart',
        label: 'label.sith.mst.sithMesMstMaterialDocument.entity.documentPart',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'documentVersion',
        label: 'label.sith.mst.sithMesMstMaterialDocument.entity.documentVersion',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'documentDescription',
        label: 'label.sith.mst.sithMesMstMaterialDocument.entity.documentDescription',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstMaterialDocument.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesMstMaterialDocument, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
